<template>
  <form ref="form">
    <div class="question-text" v-html="getQuestionText"></div>
    <div v-for="(choice, index) in getChoices" :key="index" :class="{ 'spaced': choice.spaced }">
      <div class="input-group" :class="isChecked(choice.id)">
        <label :for="`input_checkbox_`+choice.id">
          <input
            type="checkbox"
            :name="data.id"
            :id="`input_checkbox_`+choice.id"
            :value="choice.id"
            @change="selected(choice)"
          >
          <span v-html="getChoiceText(choice.id)"></span>

          <span v-if="choice.custom">
            <input
              type="text"
              :id="`custom_${choice.id}`"
              :ref="`custom_${choice.id}`"
              @keyup="setCustomValue(choice)"
            >
          </span>
        </label>
      </div>
    </div>

    <button type="button" class="previous" @click="prev">Previous</button>
    <button
      @click.prevent="next"
      :disabled="nextBtnDisabled"
      :class="{ active: !nextBtnDisabled }"
      class="next"
    >Next</button>

    <!-- <p>{{ answer }}</p> -->
  </form>
</template>

<script>
export default {
    name: 'multiple-choice',

    props: {
      data: {
        required: true,
        type: Object
      }
    },

    data() {
        return {
            nextBtnDisabled: true,
            answer: {
              question: this.data.id,
              choices: []
            },
            customValue: ''
        }
    },

    mounted(){
      if ( this.data.randomize ){
        const head = this.data.choices.filter(item => {
          return item.text[this.$parent.lang].html.substr(0,1) !== '['
        })
        head.sort(() => Math.random() - 0.5)
        const tail = this.data.choices.filter(item => {
          return item.text[this.$parent.lang].html.substr(0, 1) === '['
        })
        this.data.choices = [...head, ...tail]
      }
    },

    methods: {
        selected(choice){
          if ( choice.custom ) {
            if ( this.$refs[`custom_${choice.id}`][0].value === '' ) {
              this.$refs[`custom_${choice.id}`][0].focus();
            }
          }

          let theChoice = this.answer.choices.some(c => c.id === choice.id)
          console.log(theChoice);
          let index = this.answer.choices.findIndex(c => c.id === choice.id)

          if ( theChoice ) {// already checked so we need to remove
            this.customValue = '';
            this.answer.choices.splice(index, 1)
            document.getElementById(`input_checkbox_`+choice.id).checked = false;
            this.$refs[`custom_${choice.id}`][0].value = '';
          } else {// choice needs to be added
            this.answer.choices.push({
              "id": choice.id,
              "custom": null,
            })
            this.customValue = '';
            if ( document.getElementById(`input_checkbox_`+choice.id).checked === false ){
              document.getElementById(`input_checkbox_`+choice.id).checked = true;
            }
          }

          console.log(this.answer);
        },

        setCustomValue(choice) {
            console.log('setCustomValue %s', choice.id)
            console.log(this.$refs[`custom_${choice.id}`][0].value.trim().length);
            if ( this.$refs[`custom_${choice.id}`][0].value !== '' ) {
              this.customValue = this.$refs[`custom_${choice.id}`][0]['value'].trim();
              let theChoice = this.answer.choices.some(c => c.id === choice.id)

              if ( !theChoice ){
                this.selected(choice);
              } else {
                this.updateCustom(choice.id);
              }
            }
        },

        updateCustom(choice){
          let index = this.answer.choices.findIndex(c => c.id === choice)
          if ( index !== -1 )
            this.answer.choices[index].custom = this.customValue;
        },

        next(){
            this.$emit('next-question', this.answer)
        },

        prev() {
          this.$emit('prev-question');
        },

        isChecked(choiceId) {
          return this.answer.choices.find(c => c.id === choiceId) ? 'active' : '';
        },

        getChoiceText(choiceId) {
          const index = this.data.choices.findIndex(c => c.id == choiceId);
          const textIndex = this.data.choices[index].text.findIndex(t => t.lang == this.$parent.lang);
          return this.data.choices[index].spaced ? this.data.choices[index].text[textIndex].html.substr(1) : this.data.choices[index].text[textIndex].html;
        }
    },

    computed: {
      getQuestionText() {
        const index = this.data.text.findIndex(t => t.lang == this.$parent.lang)
        return this.data.text[index].html;
      },

      getChoices() {
        let nchoices = [];
        let answers = this.$parent.answers;
        let doifs = this.data.doifs;
        let hides = [];
        if ( doifs !== false ){
          doifs.forEach(d => {
            let group = d.group;
            group.forEach(g => {
              answers.forEach(a => {
                a.choices.forEach(ch => {
                  if(ch.id == g.idchoice && ch.custom == g.value){
                    hides.push(g.hide)
                  }
                });
              });
            })
          })
        }
        if ( hides.length > 0 ){
          nchoices = this.data.choices.filter(choice => {
            return ! hides.includes(choice.id)
          });
          return nchoices;
        } else {
          return this.data.choices;
        }
      }
    },

    watch: {
      'answer.choices': function(val) {
        if( val.length > 0){
          this.nextBtnDisabled = false
        } else {
          this.nextBtnDisabled = true
        }
      }
    }
}
</script>